/*
 * DashboardMfaLayout Messages
 *
 * This contains all the text for the DashboardMfaLayout component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.DashboardMfaLayout";

export default defineMessages(scope, {
  header: "Update MFA Options",
});
